import { ContentType, NotebookCellResource } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';
import { NotebookVisualizationResource } from '@mode/notebooks/contract';

export const editCellContent = createAction('[Cell] EditCellContent', props<{ content: string; cellToken: string }>());
export const beginEditCell = createAction('[Cell] BeginEdit', props<{ cellToken: string; cellFrozen: boolean }>());
export const updateContentType = createAction(
  '[Cell] UpdateContentType',
  props<{ contentType: ContentType; cellToken: string }>()
);

export const updateContentTypeFailure = createAction(
  '[Cell] UpdateContentType Failure',
  props<{ cellToken: string; original: NotebookCellResource; error: Error }>()
);

export const updateCell = createAction('[Cell] Update', props<{ cellToken: string }>());

export const updateCellFailure = createAction(
  '[Cell] UpdateCell Failure',
  props<{ cellToken: string; original: NotebookCellResource; error: Error }>()
);

export const updateCellSuccess = createAction(
  '[Cell] UpdateCell Success',
  props<{ cellResource: NotebookCellResource }>()
);

export const selectCell = createAction('[Cell] Select', props<{ cellToken: string; resultPane: boolean }>());

export const addCell = createAction(
  '[Cell] Add',
  props<{ notebookToken: string; content?: string; contentType?: ContentType; nextToken?: string }>()
);

export const addCellFailure = createAction('[Cell] AddFailure', props<{ notebookToken: string; error: Error }>());

export const addCellSuccess = createAction(
  '[Cell] AddSuccess',
  props<{ notebookToken: string; cellResource: NotebookCellResource; nextToken?: string }>()
);

export const moveCell = createAction(
  '[Cell] MoveCell',
  props<{ cellToken: string; notebookToken: string; down: boolean }>()
);

export const moveCellFailure = createAction(
  '[Cell] MoveCellFailure',
  props<{ error: Error; cellToken: string; nextCellToken: string; notebookToken: string }>()
);

export const addCellToLayout = createAction('[Cell] AddToLayout', props<{ cellToken: string }>());

export const addCellToLayoutSuccess = createAction(
  '[Cell] AddToLayoutSuccess',
  props<{ cellToken: string; vizResource: NotebookVisualizationResource }>()
);

export const addCellToLayoutFailure = createAction(
  '[Cell] AddToLayoutFailure',
  props<{ cellToken: string; error: Error }>()
);

export const foldCell = createAction('[Cell] Fold', props<{ cellToken: string }>());

export const foldCellSuccess = createAction('[Cell] FoldSuccess', props<{ cellToken: string }>());

export const toggleFreezeCell = createAction('[Cell] ToggleFreezeCell', props<{ cellToken: string }>());

export const toggleFreezeCellFailure = createAction(
  '[Cell] ToggleFreezeCellFailure',
  props<{ error: Error; cellToken: string }>()
);

export const removeCellFromLayout = createAction(
  '[Cell] RemoveFromLayout',
  props<{ cellToken: string; vizToken: string }>()
);

export const removeCellFromLayoutSuccess = createAction(
  '[Cell] RemoveFromLayoutSuccess',
  props<{ cellToken: string; vizToken: string }>()
);

export const removeCellFromLayoutFailure = createAction(
  '[Cell] RemoveFromLayoutFailure',
  props<{ cellToken: string; vizToken: string; error: Error }>()
);

export const destroyCell = createAction(
  '[Cell] Destroy',
  props<{
    cellToken: string;
    nextCellToken: string;
    notebookToken: string;
    notebookCellTokensArray: Map<string, string[]>;
  }>()
);
export const destroyCellFailure = createAction(
  '[Cell] DestroyFailure',
  props<{
    cellToken: string;
    notebookToken: string;
    error: Error;
  }>()
);
export const destroyCellSuccess = createAction(
  '[Cell] DestroySuccess',
  props<{
    cellToken: string;
    runToken: string;
    notebookToken: string;
    resultTokens: string[];
  }>()
);

export const endEditCell = createAction(
  '[Cell] EndEdit',
  props<{
    cellToken: string;
  }>()
);
